import DevelopmentDetailLayout from '../../components/DevelopmentDetailLayout';

function BroomfieldHouse() {
  return (
    <DevelopmentDetailLayout
      title="Broomfield House"
      metaDescription="Broomfield House, Chelmsford — Graham Care's newest development offering specialist nursing, dementia and rehabilitation care beside Broomfield Hospital."
      tagline="Our newest Graham Care development – a welcoming, contemporary home offering specialist nursing, dementia and rehabilitation care."
      subtitle="Broomfield House, Chelmsford"
    >
      <figure className="development-detail-hero">
        <img
          src="/Chelmsford_CGI02C-cladceiling.jpg"
          alt="Broomfield House interior — communal pool and wellness space"
          loading="lazy"
        />
      </figure>
      <p>
        Thoughtfully positioned beside Broomfield Hospital, the home connects healthcare, community and
        independent living within a calm, uplifting environment.
      </p>
      <p>
        Set within a wider mixed-use masterplan, Broomfield House completes a carefully planned neighbourhood
        that already includes new homes, parking and landscaped spaces. The building has been designed to
        operate independently of the surrounding residential units while acting as a gentle transition between
        the hospital and the new housing.
      </p>
      <p>
        Its elevated setting creates strong physical and visual links with the adjacent hospital, with shaped
        landform to ensure safe, accessible movement for residents and visitors alike.
      </p>

      <h3>Community Connections and Wellbeing</h3>
      <p>
        A new bus stop on Hospital Approach strengthens links for families and visitors and supports efficient
        servicing of the home. On the ground floor, a welcoming café sits alongside care suites and a local
        convenience store, creating an active, community-facing frontage.
      </p>
      <p>
        Below, a purpose-built rehabilitation centre includes a hydrotherapy pool, fully equipped gym, steam room
        and sauna — supporting residents and local people recovering post-operatively.
      </p>

      <h3>Design and Architecture</h3>
      <p>
        The external form responds to site constraints, internal planning and Graham Care's sustainability goals.
        A distinctive, glazed corner marks the communal hub and strengthens the relationship with the hospital.
        Vertical articulation, projecting elements and varied rooflines reduce the apparent scale, while a warm
        material palette — red brick, timber, render and zinc — provides character and context.
      </p>
      <p>
        Landscape works will introduce new trees and planting to create a green buffer between public and private
        spaces.
      </p>
      <p>Construction commenced Summer 2024 with target completion set for Winter 2026.</p>

      <h3>Suites and Shared Spaces</h3>
      <p>
        Every detail supports Graham Care's person-centred model, helping people maintain independence, routines
        and dignity in a home-like setting. Communal zones range from generous dining lounges in the central hub to
        quieter, more intimate areas for relaxation. Floor-to-ceiling glazing maximises natural light, with many
        rooms oriented south to enjoy sunlight and views over landscaped gardens.
      </p>
      <p>Each of the 114 care suites includes:</p>
      <ul>
        <li>Private front door</li>
        <li>Bedroom with en-suite wet room</li>
        <li>Kitchenette and dining area</li>
        <li>Access to shared lounges and balconies</li>
        <li>Discreet alarm call system with a 24/7 on-site care team</li>
        <li>Integrated assistive technology for comfort and safety</li>
      </ul>
    </DevelopmentDetailLayout>
  );
}

export default BroomfieldHouse;
